var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3398 26.2598C36.0798 28.1198 37.9998 30.6398 37.9998 33.9998V39.9998H45.9998V33.9998C45.9998 29.6398 38.8598 27.0598 33.3398 26.2598Z",
    fill: "#7A51AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24C22.4183 24 26 20.4183 26 16C26 11.5817 22.4183 8 18 8C13.5817 8 10 11.5817 10 16C10 20.4183 13.5817 24 18 24Z",
    fill: "#7A51AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 24C34.42 24 38 20.42 38 16C38 11.58 34.42 8 30 8C29.06 8 28.18 8.2 27.34 8.48C29.061 10.6084 29.9999 13.2628 29.9999 16C29.9999 18.7372 29.061 21.3916 27.34 23.52C28.18 23.8 29.06 24 30 24ZM18 26C12.66 26 2 28.68 2 34V40H34V34C34 28.68 23.34 26 18 26Z",
    fill: "#7A51AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.a1677f76292fa26d34aa2789b6e25cdb.svg";
export { ForwardRef as ReactComponent };